import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { sendRequest } from "../../hooks/requests/useRequest";



export const useInputCurves = () => {
    const { examId } = useParams();
    const [timeCurves, setTimeCurves] = useState([]);


    const formatRange = (rangeStr) => {
        const parts = rangeStr.split("-");
        if (parts.length !== 2) return rangeStr;
        
        const start = parseFloat(parts[0]).toFixed(2);
        const end = parseFloat(parts[1]).toFixed(2);
        return `${start} - ${end}`;
    };

    const getStepFromDecimals = (decimals) => {
        return Number(`0.${'0'.repeat(decimals - 1)}1`);
    };
    
    const limitDecimals = (value, maxDecimals) => {
        const regex = new RegExp(`^(\\d+)(\\.\\d{0,${maxDecimals}})?$`);
        if (value === "" || regex.test(value)) {
            return value;
        }
        return null;
    };

    function getIconForResult(result, range, isRequired, index) {
        if (!range || typeof range !== "string" || !range.includes("-")) {
            if (index === 0 && isRequired && (result === '' || result === null || result === undefined)) {
                return <i className="fa fa-warning text-danger f-16" title="Campo obligatorio" />;
            }
            return null;
        }

        const [minRange, maxRange] = range.split('-').map(s => parseFloat(s.trim()));

        if (isNaN(minRange) || isNaN(maxRange)) {
            return null; 
        }

        if (index === 0 && isRequired && (result === '' || result === null || result === undefined)) {
            return <i className="fa fa-warning text-danger f-16" title="Campo obligatorio" />;
        }
        if (index !== 0 && (result === '' || result === null || result === undefined)) {
            return null;
        }

        if (result >= minRange && result <= maxRange) {
            return <i className="fa fa-check text-success f-16" title="Resultado dentro del rango" />;
        }
        return <i className="fa fa-ban text-danger f-16" title="Resultado fuera del rango" />;
    }

    
    useEffect(() => {
            getTimeCurves();
        
    }, []);



    const GetTimesCurve = async (_id_exam) => {
    {
        const requestOptions = {
            method: "GET",
        };

        const response = await sendRequest(requestOptions, `Exam/GetTimesCurve/${_id_exam} `);

        if (response.code === 200)
            return {
                code: response.code,
                data: response.data
            }
        else if (response.code === 401)
            return response.code;
        else
            return {
                code: response.code,
                msg: response?.data?.msg
            };
        };
        
    }




    const getTimeCurves = async () => 
    {
        const listTimeCurve = await GetTimesCurve(examId);

        if (listTimeCurve.code === 200) {

            const list =  listTimeCurve?.data.map(_find => {
                return {
                    value: _find?.id_curve_time ?? 0,
                    label: _find?.label ?? "----",
                    time_in_minutes: _find?.time_in_minutes
                }
            });
            setTimeCurves(list)
        }  
    }


    return {
        formatRange, getStepFromDecimals, limitDecimals, getIconForResult, timeCurves


    }
}